const useSchemaTests = (schema) => {

    const schemaRequired = !!(schema?.tests.find(({ name }) => name === "required"));
    const schemaMaxLength = schema?.tests.find(({ name }) => name === "max" || name === "length");
    const schemaMaxLengthValue =
        schemaMaxLength && (schemaMaxLength.params.max || schemaMaxLength.params.length)

    return [schemaRequired, schemaMaxLengthValue];
}

export default useSchemaTests;